import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Esto asegura que el scroll sea suave
        });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
